import React, { useEffect, Fragment } from 'react'
import { Autocomplete, TextField, Box, Chip, Typography, FormHelperText, Checkbox, CheckboxProps, makeStyles, Popper, ListItem } from '@mui/material';
import PropTypes, { InferProps } from "prop-types";
import { useFormContext } from "react-hook-form"
import { withStyles } from '@mui/styles';
import { green } from '@mui/material/colors';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import './FormIndex.css';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MultiSelectForm({
    options,
    label,
    disabled,
    name,
    limitTag,
    required,
    subLabel,
    autoSelect,
    fullWidth,
    onChange,
    onToggleOption,
    // onSelectAll,
    onClearOptions,
    selectAllLabel = currentLanguage() == "th" ? "เลือกทั้งหมด" : "All",
    disableClearable,
    IsRadius,
    getOptionDisabled,
    valueDisable,
    fixedOptions = [],
    shrink,
}: InferProps<typeof MultiSelectForm.propTypes>) {
    const {
        register,
        getValues,
        setValue,
        watch,
        formState: { errors },
    } = useFormContext();

    const handleToggleSelectAll = (selectedOptions) => {

        const allSelected = options.length === (getValues(name) || []).length;
        let chkFix = (getValues(name) || []).filter(f=>f == fixedOptions[0]);
        let chkData = chkFix.length > 0 ? [] : fixedOptions[0] ?? []
        if (!allSelected) {
            
            setValue(name, [...chkData, ...options.map(m => m.value)], { shouldValidate: true });
            onChange && onChange(options);
        } else {
            setValue(name, fixedOptions);
            onChange && onChange([]);
        }
    };

    const handleChange = (event, selectedOptions, reason) => {
        let chkFix = (getValues(name) || []).filter(f=>f == fixedOptions[0]);
        let chkData = chkFix.length > 0 ? [] : fixedOptions[0] ?? []

        if (reason === "selectOption" || reason === "removeOption") {
            if (selectedOptions.find(option => option.value === "999")) {
                handleToggleSelectAll(selectedOptions);
            } else {
                // onToggleOption && onToggleOption(selectedOptions);
                setValue(name, [...chkData, ...selectedOptions.map(m => m.value)], { shouldValidate: true })
                onChange && onChange(selectedOptions);
            }
        } else if (reason === "clear") {

            onClearOptions && onClearOptions();
            setValue(name, fixedOptions, { shouldValidate: true });
            onChange && onChange([]);
        }
    };


    const valueFrom = () => {

        let sValue = watch(name);
        if (sValue && options) {
            return sValue.map((value) =>
                options.find((option) => option.value === value),
            );
        }
        return [];
    };

    const PopperCustom = React.useCallback((props) => {
        return <Popper 
                    {...props} 
                    // anchorEl={anchorEl} 
                    // style={{ width: anchorEl.clientWidth }} 
                    // style={{ width: anchorEl.offsetWidth }} 
                    placement='bottom' 
                    modifiers={[
                        {
                          name: 'flip',
                          enabled: false,
                          options: {
                            altBoundary: true,
                            rootBoundary: 'document',
                            padding: 8,
                          },
                        },
                      ]}
                />;
    }, []);

    return (
        <div>
            <Autocomplete
                size={"small"}
                id={name}
                {...register(name)}
                multiple
                disableCloseOnSelect
                selectOnFocus
                PopperComponent={PopperCustom}
                onChange={handleChange}
                placeholder={label || ""}
                limitTags={limitTag || 1}
                disableClearable={disableClearable || disabled || false}
                getOptionLabel={(option: any) => option.label}
                options={options}
                value={valueFrom()}
                getOptionDisabled={getOptionDisabled || disabled || false}
                // getOptionDisabled={() => (disabled || false)}
                disabled={disabled || undefined}
                filterOptions={(options, params) => {
                    const filtered = params.inputValue ? options.filter((f: any) => f.label.toLowerCase().includes(params.inputValue.toLowerCase())) : options;
                    return [{ label: selectAllLabel, value: "999" }, ...filtered];
                }}
                sx={{
                    ".MuiAutocomplete-tag": {
                        maxWidth: limitTag <= 1 ? "calc(73% - 4px) !important" : "calc(100% - 4px)"
                    }
                }}

                renderTags={(tagValue, getTagProps) => {
                    if (tagValue != undefined) {
                        return (
                            <React.Fragment>
                                {
                                    tagValue.slice(0, limitTag).map((option: any, index) => (
                                        <Chip size={"small"} {...getTagProps({ index })} label={option.label} disabled={option.disabled || disabled || false} />
                                    ))
                                }
                                {
                                    tagValue.length > (limitTag) ? <Chip size={"small"} label={"+" + (tagValue.length - (limitTag))} disabled={disabled || false} /> : <React.Fragment></React.Fragment>
                                }
                            </React.Fragment>
                        )
                    }
                }}
                renderOption={(props, option, { selected }) => (
                    <li {...props} key={option.value}>
                        <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={((getValues(name) || []).length > 0 && option.value === "999" && options.length === (getValues(name) || []).length) || selected ? true : selected}
                        />
                        {option.label}
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                        size={"small"}
                        inputRef={register(name).ref}
                        {...params}
                        fullWidth={fullWidth}
                        style={{ width: '100%' }}
                        error={Boolean(errors[name])}
                        InputLabelProps={{
                            disabled: disabled || false,
                            // shrink: shrink || true,
                        }}
                        sx={{
                            " > label": {
                                " > span": {
                                    fontSize: "12px",
                                    " ::before": {
                                        content: `"${required ? ' *' : ''}"`,
                                        color: "red"
                                    }
                                },
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: IsRadius ? "50px" : "4px",
                               
                              },
                            "label.MuiInputLabel-shrink": {
                                backgroundColor: "rgba(255,255,255,0.95)"
                            },
                            ".MuiOutlinedInput-notchedOutline > legend": {
                                fontSize: "0.01em",
                            },
                            ".Mui-disabled": {
                                backgroundColor: "#f1f1f1",
                                color: "#000000"
                
                              },
                        }}
                        label={
                            label ?
                        <Fragment>
                            {label}
                            <Typography fontWeight={600} component="span">{` ${subLabel}`}</Typography>
                        </Fragment>
                        : null
                        }
                    />
                )
                }
            />
            {errors && errors[name] ? (
                <FormHelperText sx={{ color: "red" }}>
                    {errors[name].message ? errors[name].message : "กรุณาเลือกอย่างน้อย 1 รายการ"}
                </FormHelperText>
            ) : null}
        </div>
    )
}

MultiSelectForm.propTypes = {
    required: PropTypes.bool,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    hint: PropTypes.string,
    options: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    // multiple: PropTypes.bool,
    limitTag: PropTypes.number,
    subLabel: PropTypes.string,
    autoSelect: PropTypes.bool,
    shrink: PropTypes.bool,
    fullWidth: PropTypes.bool,
    disableClearable: PropTypes.bool,
    onChange: PropTypes.any,
    onToggleOption: PropTypes.any,
    // onSelectAll: PropTypes.any,
    onClearOptions: PropTypes.any,
    selectAllLabel: PropTypes.string,
    getOptionDisabled: PropTypes.any,  
    valueDisable: PropTypes.any, 
    fixedOptions: PropTypes.any, 
    IsRadius: PropTypes.bool,

};

MultiSelectForm.defaultProps = {
    required: false,
    disabled: false,
    // multiple: false,
    prefixText: "",
    subLabel: "",
    autoSelect: false,
    fullWidth: true,
    limitTag: 1,
    disableClearable : false,
    valueDisable: "0",
    fixedOptions:[],
    IsRadius: false,
    getOptionDisabled: function defaultValue() {
     return false;
    }
};